"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const isNil_1 = __importDefault(require("lodash/isNil"));
const formatNumber_1 = __importDefault(require("./formatNumber"));
const removeExtraFractionZeros_1 = __importDefault(require("./removeExtraFractionZeros"));
const KB = 1024;
const MB = 1024 * 1024;
const GB = 1024 * 1024 * 1024;
function formatBytes(value, maximumFractionDigits = 3, transform = 'pretty', thousandsSeparator = '') {
  if ((0, isNil_1.default)(value)) value = 0;
  switch (transform) {
    case 'b':
      return (0, formatNumber_1.default)(value, 0) + 'b';
    case 'kb':
      return (0, removeExtraFractionZeros_1.default)((0, formatNumber_1.default)(value / KB, maximumFractionDigits, thousandsSeparator)) + 'Kb';
    case 'mb':
      return (0, removeExtraFractionZeros_1.default)((0, formatNumber_1.default)(value / MB, maximumFractionDigits, thousandsSeparator)) + 'Mb';
    case 'gb':
      return (0, removeExtraFractionZeros_1.default)((0, formatNumber_1.default)(value / GB, maximumFractionDigits, thousandsSeparator)) + 'Gb';
    default:
      if (value < KB) {
        return formatBytes(value, 0, 'b', thousandsSeparator);
      } else if (value < MB) {
        return formatBytes(value, maximumFractionDigits, 'kb', thousandsSeparator);
      } else if (value < GB) {
        return formatBytes(value, maximumFractionDigits, 'mb', thousandsSeparator);
      } else {
        return formatBytes(value, maximumFractionDigits, 'gb', thousandsSeparator);
      }
  }
}
exports.default = formatBytes;